module.exports = __webpack_public_path__ + "img/repeat-order.6dc15716.png";